export const enum SUBSCRIPTIONS_ACTIONS {
  // Module name
  MODULE_SUBSCRIPTIONS = "Subscriptions",

  // Actions
  UNSUBSCRIBE = "unsubscribe",
  UNSUBSCRIBE_ALL = "unsubscribeAll",
  SUBSCRIBE_MEETING_INVITATIONS = "subscribeMeetingInvitations",
  AUTO_RESET_TRIGGER_STATUS = "autoResetTriggerStatus",

  // Getters
  GET_STATUS_TRIGGER = "getStatusTrigger",
}
